import axios from "axios";
import { publicApiUrl, signedInApiUrl } from "../util/Constants";
import type {
  LadderCreatePayload,
  LadderDetail,
  LadderUpdatePayload,
  OrganizableLadder,
  UnofficialLadderRow,
} from "../types/domain";

export const laddersApi = {
  listUnofficial: async (): Promise<UnofficialLadderRow[]> => {
    const { data } = await axios.get<UnofficialLadderRow[]>(`${publicApiUrl}/ladders/unofficial`);
    return data;
  },

  getDetail: async (id: number | string): Promise<LadderDetail> => {
    const { data } = await axios.get<LadderDetail>(`${publicApiUrl}/ladders/${id}`);
    return data;
  },

  create: async (payload: LadderCreatePayload): Promise<LadderDetail> => {
    const { data } = await axios.post<LadderDetail>(`${signedInApiUrl}/ladders`, payload);
    return data;
  },

  update: async ({ id, payload }: { id: number; payload: LadderUpdatePayload }): Promise<LadderDetail> => {
    const { data } = await axios.put<LadderDetail>(`${signedInApiUrl}/ladders/${id}`, payload);
    return data;
  },

  addOrganizer: async ({ ladderId, userId }: { ladderId: number; userId: number }): Promise<LadderDetail> => {
    const { data } = await axios.post<LadderDetail>(`${signedInApiUrl}/ladders/${ladderId}/organizers/${userId}`);
    return data;
  },

  removeOrganizer: async ({ ladderId, userId }: { ladderId: number; userId: number }): Promise<LadderDetail> => {
    const { data } = await axios.delete<LadderDetail>(`${signedInApiUrl}/ladders/${ladderId}/organizers/${userId}`);
    return data;
  },

  transferOwnership: async ({ ladderId, newOwnerUserId }: { ladderId: number; newOwnerUserId: number }): Promise<LadderDetail> => {
    const { data } = await axios.put<LadderDetail>(`${signedInApiUrl}/ladders/${ladderId}/owner/${newOwnerUserId}`);
    return data;
  },

  listOrganizableByMe: async (): Promise<OrganizableLadder[]> => {
    const { data } = await axios.get<OrganizableLadder[]>(`${signedInApiUrl}/ladders/organizable-by-me`);
    return data;
  },
};
